<script>
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vue2Dropzone from "vue2-dropzone";

import SuppliersApi from "@/services/suppliers-api";
import CountriesApi from "@/services/countries-api";
import UsersApi from "@/services/users-api";
import ItemsApi from "@/services/items-api";
import CustomerApi from "@/services/customers-api";



export default {
      components: {ckeditor: CKEditor.component, vueDropzone: vue2Dropzone},

    props: {
      isLaboratory:{
        type: Boolean,
        default:false
      },
      isProvider:{
        type: Boolean,
        default:false
      },
      isCustomer:{
        type: Boolean,
        default:false
      },
    },
  data() {
    return {
        passwordHidden: false,
        
        usersFilter:null,
        usersStatusFilter:true,
        usersTrialFilter: null,
        usersPaymentFilter: null,
        
        usersList: [],
        customersList:[],
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        type:null,
        isItemsTableBusy:false,
        showDetailsModal:false,
        showConditionsModal:false,
        selectedLogo:null,
        citiesList:[],
        townsList:[],
        localityList:[],
        countriesList:[],
        selectedCountry:null,
        if_form_error:false,
        showContactModal:false,
        showForm:false,
        expiredItemReturnList:[{name :"Oui",value: true},{name :"Non", value: false}],
        selectedContact: {id:'', firstName:'', lastName:'', phone:'', email:'', position:'' ,supplierId:null},
        selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1,},
        showUsersModal:false,
        isNew:false,
        selectedUserList:[],
        isPasswordChange:false,
        newPassword:null,
        selected:{id:null, 
            status:1,
            name: null,
            legalName:null,
            address: null,
            zipCode:null,
            country:null,
            city:null,
            town:null,
            locality:null,
            phone:null,
            secondPhone:null,
            mail:null,
            bank:null,
            rib: null,
            webSite:null,
            facebook:null,
            instagram:null,
            offertype:1,
            type:null,
            taxRefNumber: null,
            cashPaymentDiscount:0,
            invoiceDiscount:0,
            note:null,
            minOrderValue:0,
            minOrderItemsCount:0,
            paymentDays:0,
            deliveryDays:0,
            expiredItemReturn:{name:'',value:null},
            expiredItemReturnString:null,
            description:''},    
            editor: ClassicEditor,
            dropzoneOptions: {
                url: "/",
                thumbnailWidth: 150,
                // maxFileSizeInMB: 1,
                addRemoveLinks: true,
                autoProcessQueue:false,
                
            },
            showImageModal: false,
            imageModalUrl: '',
            changeLogo:null,
            maxFileSize: null,
            filesModal:false,
            filesList:[],
            selectedPDF:null,
            isfilesListBusy:false,
            noFileSelectedError:false,
            isPreOrderSupported:false,
            isInvoicingSupported: false,
            isVisibleInList: false,
            imageModalSelectedItem:{name:""}
           
      }
    },
    
  mounted() {
    if(this.isLaboratory) {
        this.type=0
      }
    if(this.isProvider) {
        this.type=1
      }
    this.findUsers()
    this.getMaxFileSize();
    this.getCountries()
  },

   

  methods: {
    getMaxFileSize(){
        ItemsApi.getMaxFileSize().then(
            size => {
                this.maxFileSize=size;
            })
    },
    addPayment(client, state) {
  Swal.fire({
    title: state ? "Activer l'inscription" : "Désactiver l'inscription",
    html: state
      ? "Êtes-vous sûr de vouloir <strong>activer</strong> l'abonnement de l'année en cours pour <strong>" + client.name + "</strong>"
      : "Êtes-vous sûr de vouloir <strong>désactiver</strong> l'abonnement de l'année en cours pour <strong>" + client.name + "</strong>",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#34c38f",
    cancelButtonColor: "#f46a6a",
    cancelButtonText: "Annuler",
    confirmButtonText: state ? "Oui, activer" : "Oui, désactiver"
  }).then(result => {
    if (result.value) {
      // L'utilisateur a confirmé, appelons la méthode updatePayments
      this.updatePayments(client.id, state);
    }
  });
},

updatePayments(customerId, paymentState) {
    CustomerApi.updatePayment(customerId, paymentState).then(
        (result)=> {
            if(result){
                this.findUsers()
            }
        }
      )
},
    findUsers(){
          this.isItemsTableBusy = true;
          if(this.isLaboratory || this.isProvider){
            SuppliersApi.getAllSuppliersForAdmin(this.usersFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.type).then(
                response => {
                    this.usersList = response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
        }
      )   .finally(() => {
        this.isItemsTableBusy = false;
      })
          }

          if(this.isCustomer){
              CustomerApi.getAllCustomers(this.usersFilter, this.usersStatusFilter,this.usersTrialFilter ,this.usersPaymentFilter ,this.pagemodelMain.currentPage, this.pagemodelMain.perPage).then(
                  response => {    
                    this.usersList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;


                  }
              )
              .finally(() => {
             this.isItemsTableBusy = false;
      });
          } 

        //   if(this.isCustomer){
        //       findCustomers()
        //   }
        //   if(this.isProvider){
        //       findProviders()
        //   }
      },
      
    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
        this.townsList=[]
        this.localityList=[]
        this.citiesList=[]
        var id = this.selected ? (this.selected.country ? this.selected.country.id : null) : null
        if(id == null){
            return;
        }
       CountriesApi.getCities(id).then(
          result => {
            this.citiesList = result
        })
     },

    getTowns(){
        this.townsList=[]
        this.localityList=[]
        var id = this.selected ? (this.selected.city ? this.selected.city.id : null) : null
        if(id == null){
            return;
        }

       CountriesApi.getTowns(id).then(
          result => {
            this.townsList = result
        })
     },

     getLocalities(){
        this.localityList=[]
        var id = this.selected ? (this.selected.town ? this.selected.town.id : null) : null
        if(id == null){
            return;
        }

       CountriesApi.getLocalities(id).then(
          result => {
            this.localityList = result
        })
     },

     saveSupplier(){
         this.selected.supplierType=this.type
         this.selected.expiredItemReturnValue=this.selected.expiredItemReturn ? this.selected.expiredItemReturn.value : null
        SuppliersApi.saveSupplier(this.selected).then(
        (result)=> {
            if(result){
                this.findUsers()
                this.showDetailsModal=false              
                this.cancelEdit()

            }

        }
      )
     },

         saveCustomer(){
        CustomerApi.saveCustomer(this.selected).then(
        (result)=> {
            if(result){
                this.findUsers()
                this.showDetailsModal=false
                this.cancelEdit()
                
            }
        }
      )
     },

     addNewSupplier(){
         this.showDetailsModal=true
         this.cancelEdit()
     },

    cancelEdit(){
        this.if_form_error=false;
        this.selected= {
            id:null,
            status:1,
            name: null,
            legalName: null,
            address: null,
            zipCode:null,
            country:null,
            city:null,
            town:null,
            locality:null,
            phone:null,
            secondPhone:null,
            mail:null,
            bank:null,
            rib: null,
            webSite:null,
            facebook:null,
            instagram:null,
            offertype:1,
            cashPaymentDiscount:0,
            invoiceDiscount:0,
            minOrderValue:0,
            minOrderItemsCount:0,
            paymentDays:0,
            deliveryDays:0,
            expiredItemReturn:{name:'',value:null},
            expiredItemReturnString:null,
            description:'',
            type:0,
            taxRefNumber:null,
            isPreOrderSupported: false,
            isInvoicingSupported: false,
            isVisibleInList: false,
            note:null
        };

    },

    edit(data){
    this.cancelEdit();
    this.selected.id = data.id;
    this.selected.status = data.status;
    this.selected.name = data.name;
    this.selected.address = data.address;
    this.selected.zipCode=data.zipCode;
    this.selected.country = data.country;
    this.selected.city =  data.city;
    this.selected.town =  data.town;
    this.selected.locality =  data.locality;
    this.selected.phone=data.phone;
    this.selected.secondPhone=data.secondPhone;
    this.selected.mail=data.mail;
    this.selected.bank=data.bank;
    this.selected.rib=data.rib;
    this.selected.webSite=data.webSite;
    this.selected.facebook=data.facebook;
    this.selected.instagram=data.instagram;
    this.selected.offertype=data.offertype;
    this.selected.cashPaymentDiscount=data.cashPaymentDiscount;
    this.selected.invoiceDiscount=data.invoiceDiscount;
    this.selected.minOrderValue=data.minOrderValue;
    this.selected.minOrderItemsCount=data.minOrderItemsCount;
    this.selected.paymentDays=data.paymentDays;
    this.selected.deliveryDays=data.deliveryDays;
    this.selected.expiredItemReturn.value=data.expiredItemReturn;
    this.selected.expiredItemReturn.name=data.expiredItemReturn ? 'Oui' : 'Non';
    this.selected.expiredItemReturnString=data.expiredItemReturnString;
    this.selected.description=data.description;
    this.selected.type=data.type;
    this.selected.taxRefNumber=data.taxRefNumber;
    this.selected.isPreOrderSupported =  data.isPreOrderSupported;
    this.selected.isInvoicingSupported = data.isInvoicingSupported;
    this.selected.isVisibleInList = data.isVisibleInList;
    this.selected.legalName = data.legalName;
    this.selected.note=data.note
    },

getUserInfo(id){
    UsersApi.getUserInfo(id,this.isCustomer).then(
          result => {
              this.selectedUserList=result
              this.showUsersModal=true
        })

},

    addNew(){
      this.cancelUserEdit();
      this.showForm =true;
      this.isNew=true
      this.isPasswordChange=false
    } ,

    cancelContactEdit(){
      this.selectedContact.id=null
      this.selectedContact.firstName=''
      this.selectedContact.lastName=''
      this.selectedContact.phone=''
      this.selectedContact.email=''
      this.selectedContact.position=''
      this.selectedContact.supplierId=null;
    },

    cancelUserEdit(){
      this.isNew=false
      this.selectedUser.id=null
      this.selectedUser.name=''
      this.selectedUser.userName=''
      this.selectedUser.password=''
    },


    hideForm(){
      this.showForm =false;
      this.isNew=false
    },

    findContacts(id){
        UsersApi.findContacts(id).then(
            result =>{
                this.selected.contacts = result
            }
        )
    },

    saveContact(){
      this.selectedContact.supplierId= this.selected ? this.selected.id : null
      UsersApi.saveContact(this.selectedContact).then(
        ()=> {
          this.findContacts(this.selectedContact.supplierId)
          this.cancelContactEdit()
          this.hideForm()
        }
      )
    },

    editContact(contact){
      this.showForm =true;
      this.cancelContactEdit();
      this.selectedContact.id=contact.id
      this.selectedContact.firstName=contact.firstName
      this.selectedContact.lastName=contact.lastName
      this.selectedContact.phone=contact.phone
      this.selectedContact.email=contact.email
      this.selectedContact.position=contact.position
    },
    editUser(user){
        this.showForm =true;
        this.isPasswordChange=false
        this.cancelUserEdit();
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
        this.selectedUser.status=user.status
    },

    removeContact(contact){
      Swal.fire({
        title: "Supprimer ?",
        html: contact.firstName+' '+contact.lastName,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result => {
        if (result.value) {
            contact.supplierId= this.selected ? this.selected.id : null
            UsersApi.removeContact(contact)
            .then(() =>{
                this.findContacts(contact.supplierId)
                }) 
        }
    })

    },

    saveUser(){
        if(this.isCustomer){
             this.selectedUser.customerId= this.selected ? this.selected.id : null
             this.selectedUser.supplierId= null
        }else{
            this.selectedUser.supplierId= this.selected ? this.selected.id : null
            this.selectedUser.customerId= null

        }


      UsersApi.saveUser(this.selectedUser).then(
        (result)=> {
            if(result){
                this.getUserInfo( this.isCustomer ?  this.selectedUser.customerId :this.selectedUser.supplierId)          
                this.cancelUserEdit()
                this.hideForm()
            }

        }
      )
    },

    showHidePassword() {
        if(this.passwordHidden){
            this.passwordHidden = false;
        }else{
            this.passwordHidden = true;
        }
    },


    // removeUser(user){
    //   Swal.fire({
    //     title: "Supprimer ?",
    //     html: user.name,
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#34c38f",
    //     cancelButtonColor: "#f46a6a",
    //     cancelButtonText: "Annuler",
    //     confirmButtonText: "Oui, supprimer!"
    // }).then(result => {
    //     if (result.value) {
    //         user.supplierId= this.selected ? this.selected.id : null
    //         UsersApi.removeUser(user)
    //         .then(() =>{
    //             this.getUserInfo(user.supplierId)
    //             }) 
    //     }
    // })

    // },

    changePassword(user){
        this.isPasswordChange = true
        this.hideForm()
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
        this.newPassword=null
    },
    cancelPasswordChangeEdit(){
        this.isPasswordChange= false
        this.cancelUserEdit()
        this.newPassword=null
    },

    updatePassword(){
        this.selectedUser.supplierId= this.selected ? this.selected.id : null
        UsersApi.adminUpdatePassword(this.selectedUser.id,this.newPassword).then(
        (result)=> {
            if(result){
                this.getUserInfo(this.selectedUser.supplierId)          
                this.cancelPasswordChangeEdit()
            }
            
        }
      )
    },

        uploadImage(){
      const fd = new FormData();
      fd.append('file', this.changeLogo, this.changeLogo.name)
      UsersApi.uploadLogo(fd,this.imageModalSelectedItem.id).then(
        res => {
          if(res){
            this.showImageModal=false
            this.findUsers()
          }
        }
      )
    },
        
    onImageUpload(event) {
        this.changeLogo=event.target.files[0];
        this.uploadImage() 

    },

    deleteImage() {
      Swal.fire({
          title: "Supprimer le logo ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer!"
      }).then(result => {
          if (result.value) {
              UsersApi.deleteLogo(this.imageModalSelectedItem.id)
              .then(() =>{
                    this.showImageModal=false
                   this.findUsers()
                  }) 
          }
      })
    },

    getProvidersFiles(selecteProvider){
        this.isfilesListBusy=true,
      SuppliersApi.getProvidersFiles(selecteProvider.id).then(
        result => {
          this.filesList = result;
        }
      ).finally(()=>{
          this.isfilesListBusy=false;});
          
    },

    saveProvidersFiles(){
        this.selectedPDF=this.$refs.myVueDropzone.getAcceptedFiles()[0]
        if(!this.selectedPDF){
            this.noFileSelectedError=true
            return ;
        }
        const fd = new FormData();
        fd.set('file',this.selectedPDF)
        SuppliersApi.saveProvidersFiles(fd,this.selected.id).then(
            result => {
                if(result){
                    this.getProvidersFiles(this.selected)
                    this.$refs.myVueDropzone.removeAllFiles()
                }
            
            }
            ) 
    },

    exportPDF(fileGeneratedName,fileName){
      SuppliersApi.exportPDF(fileGeneratedName,fileName )
    },

    exportCsv(){
        CustomerApi.exportCsv()
    },

    deletePDF(id,generatedName){
      Swal.fire({
        title: "Supprimer le fichier ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result=>{
      if(result.value){
        SuppliersApi.deleteProvidersFile(id,generatedName).then(
          ()=>{
            this.getProvidersFiles(this.selected)
          }
        )
      }
    }
      )
    },
},
watch : {
    usersStatusFilter : function() {
         this.findUsers();
    },
    usersTrialFilter : function() {
         this.findUsers();
    },
    usersPaymentFilter : function() {
         this.findUsers();
    }
  }


};
</script>
<template>
    <div class="row   ">    
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Comptes
                    <span class="d-none d-sm-inline   ">
                         des {{this.isLaboratory ? 'Fournisseurs' : (this.isProvider ? 'Prestataires' : (this.isCustomer ? 'Clients' :''))}} 
                    </span>
                </h2>
                </div>

                <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-end">
                    <b-button v-if="isCustomer " variant="success" @click="exportCsv" class="mb-4 mr-2 ">
                        <i class="fas fa-file-csv font-size-18 font-weight-bold align-middle mr-2"></i> 
                        <span class=" font-weight-bold">Exporter
                        </span>
                    </b-button>

                    <b-button variant="primary" @click="addNewSupplier();getCities()" class="mb-4 ml-2">
                        <i class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2"></i> 
                        <span class=" font-weight-bold">Nouveau
                            <!-- {{this.isLaboratory ? 'Nouveau fournisseur' : (this.isProvider ? 'Nouveau prestatire' : (this.isCustomer ? 'Nouveau client' :'Nouveau'))}}  -->
                        </span>
                    </b-button>
                </div>

            </div>
 
            <div v-if="isCustomer" class="row p-0 m-0 pb-4">
                <div class ="col-12 col-sm-3 pr-sm-2">

                    <b-form-checkbox
                            value="true"
                            unchecked-value="false"
                            class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-0 mt-0"
                            v-model="usersStatusFilter">
                            <span :class="usersStatusFilter === 'true' ? 'text-primary' : 'text-muted'" > Officines Actives </span>
                    </b-form-checkbox>

                    <!-- <v-select class="style-vselect" :options="customerList" v-model="selectedCustomer"  placeholder="Chercher par officine" label="name" >
                      <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select>  -->
                </div>

                <div class ="col-12 col-sm-3 pl-sm-2">

                    <b-form-checkbox
                            value="true"
                            unchecked-value="false"
                            class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                            v-model="usersTrialFilter" >
                            <span :class="usersTrialFilter === 'true' ? 'text-success' : 'text-muted'" > En Période d'Essai </span>
                    </b-form-checkbox>
                </div>

                <div class ="col-12 col-sm-3 pl-sm-2">

                    <b-form-checkbox
                            value="true"
                            unchecked-value="false"
                            class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                            v-model="usersPaymentFilter" > 
                            <span :class="usersPaymentFilter === 'true' ? 'text-success' : 'text-muted'" > En attente de Paiement </span>
                    </b-form-checkbox>
                </div>



            </div>

            <div class="row p-0 m-0 pb-4">
                <div class ="col-sm-12">
                    <b-input-group  >
                        <b-form-input placeholder="Chercher par nom"  v-model="usersFilter"   @keyup.native.enter="findUsers()"
                            ></b-form-input>                              
                        <template v-slot:append>
                            <b-button variant="success" @click="findUsers()">
                            <i class="bx bx-search-alt font-size-16 align-middle"></i>
                            </b-button>
                        </template>
                    </b-input-group>
                </div>
            </div>

            <div class="row ">
                <div class ="col-sm-12">
                    <div class="card border border-info bg-Default">
                    <div class="table-responsive mb-0">
                    <table class="table table-centered table-fixed ">
                        <thead class="thead-light">
                            <tr>
                                <th v-if="isLaboratory || isProvider"  class="text-center d-sm-table-cell d-none ">Logo</th>
                                <th class="text-left " >Nom </th>
                                <th class="text-left " >Date de création </th>
                                <th v-if="isCustomer" class="text-left d-sm-table-cell d-none ">Date de paiement</th>
                                <!-- <th class="text-left d-sm-table-cell d-none ">Pays</th> -->
                                <th class="text-left d-sm-table-cell d-none">Ville</th>
                                <th v-if="isCustomer" class="text-left d-sm-table-cell d-none ">Numéro de téléphone</th>
                                <th v-if="isLaboratory" class="text-left d-sm-table-cell d-none "> Type d'Offres</th>
                                <th v-if="isCustomer" class="text-left d-sm-table-cell d-none "> Type de pharmacie</th>
                                <th v-if="isLaboratory" class="text-center  d-sm-table-cell d-none">Nombre d'Offres</th>
                                <th class="text-center"> Actif</th>
                                <th v-if="isCustomer" class="text-center">Periode d'Essai</th>
                                <th v-if="isCustomer" class="text-center">Paiement</th>
                                <th v-if="isLaboratory" class="text-center"> Catalogue</th>
                                <th class="text-center" v-if="isLaboratory || isProvider"> Contacts</th>
                                <th class="text-center"> Utilisateurs</th>
                                
                                <th class="text-center" v-if="isProvider" >Piéces Jointes</th>
                                <th></th>

                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in usersList" :key="data.id" >
                            <td v-if="isLaboratory || isProvider" class="text-center d-sm-table-cell d-none" >
                                <img v-bind:src="'/api/image/get/' + data.logo" @click="imageModalUrl= '/api/image/get/' + data.logo;showImageModal = true; imageModalSelectedItem=data" alt height="40" width="60" style="cursor: pointer;" />
                            </td>
                            <td class="text-left font-weight-bold font-size-14">{{data.name}}</td>
                            <td class="text-left">{{data.creationDate}}</td>
                            <td class="text-left d-sm-table-cell d-none " v-if="isCustomer">{{data.lastPaymentDate}}</td>
                            <!-- <td class="text-left d-sm-table-cell d-none" >{{data.country.name}}</td> -->
                            <td class="text-left d-sm-table-cell d-none" >{{data.city.name}}</td>
                            <td class="text-left  d-sm-table-cell d-none" v-if="isCustomer">{{data.phone}}<span v-if="data.secondPhone">- {{data.secondPhone}}</span></td>
                            <td class="text-left d-sm-table-cell d-none " v-if="isLaboratory">
                                <span  class="font-size-13"
                                :class="data.offertype===1 ? 'badge ml-1 badge-warning badge-pill' : 'badge ml-1 badge-primary   badge-pill' ">{{data.offertype===1 ? 'Sans Catégories' : 'Avec Catégories'}}
                                </span>
                            </td> 
                             <td class="text-left d-sm-table-cell d-none" v-if="isCustomer">
                                 
                                <span  class="font-size-13"
                                :class="data.type==0 ? 'badge ml-1 badge-warning badge-pill' : (data.type==1 ?'badge ml-1 badge-dark   badge-pill':'') ">
                                <i :class="data.type==1 ? 'fas fa-moon':'far fa-sun'"></i> {{data.type===0 ? 'Jour' : (data.type===1 ?'Nuit':'') }}
                                </span>
                            </td> 
                            
                            <td class="text-center font-weight-bold text-dark font-size-16 d-sm-table-cell d-none" v-if="isLaboratory">{{data.offersCount}}</td>
                            <td class="text-center"> 
                                <i :class="data.status===1 ? 'fas fa-user text-success' : 'fas fa-user-slash text-danger' " ></i>
                            </td>

                            <td class="text-center" v-if="isLaboratory"> 
                                <i :class="data.isVisibleInList ? '' : 'fas fa-eye-slash text-danger' " ></i>
                            </td>

                            <td class="text-center" v-if="isCustomer">
                                <i :class="data.trail ? 'fas fa-question-circle font-size-14 text-warning' : ''" ></i>
                            </td>

                            <td v-if="isCustomer" class="text-center">
                                <i :class="[data.isCurrentYearPaid ? 'text-success fa fa-check-circle' : 'text-danger fa fa-times-circle' ]" @click="addPayment(data, !data.isCurrentYearPaid)" style="cursor: pointer;"></i>
                            </td >

                            <td class="text-center" v-if="isLaboratory || isProvider" > 
                                 <i class="far fa-address-card  text-primary font-weight-bold font-size-14" @click="selected=data;hideForm();showContactModal = true" style="cursor:pointer" title="gérer les contacts" ></i>
                            </td>
                            <td class="text-center"> 
                                <i class="fas fa-users-cog text-primary font-weight-bold font-size-14" @click="selected=data;hideForm();isPasswordChange=false;getUserInfo(data.id);" style="cursor:pointer" title="gérer les utilisateurs" ></i>
                            </td>
                            <td v-if="isProvider" class="text-center"> 
                                <i class="fas fa-file text-primary font-weight-bold font-size-14" @click="filesModal=true;getProvidersFiles(data);selected=data" style="cursor:pointer" title="gérer les utilisateurs" ></i>
                            </td>
                            
                            <td>
                                <a  title="modifier" href="javascript:void(0);"  @click="edit(data);showDetailsModal=true;getCities();getTowns();getLocalities()" :class="data.id ? '' : 'd-none'" class="action-icon text-warning pr-2" >
                                    <i class="fas fa-edit  font-size-16"  />
                                </a>
                            </td>
                            

                        </tr>
                        </tbody>
                    </table>
                    <div v-if="isItemsTableBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
                    </div>
                    <span v-if="!isItemsTableBusy & !usersList.length " class="d-flex justify-content-center m-4 text-danger" >
                        {{this.isLaboratory ? 'Aucun fournisseur dans la liste' : (this.isProvider ? 'Aucun Prestatire dans la liste' : (this.isCustomer ? 'Aucun client dans la liste' :'Aucun utilisateur dans la liste'))}}       
                    </span>
                    </div>
                    </div>
                    <!-- Pagination -->
                    <div class="row pt-3 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="findUsers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findUsers()" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                </div>

            </div> 
          </div>
        </div>
      </div>


    <b-modal v-model="filesModal" 
    title="Piéces Jointes" 
    hide-footer 
    centered 
    title-class="text-warning"
    title-tag="h5"
    header-close-variant="danger">

    <div class="zoom-container">
    <div class="row">
        <!-- <div v-for="file in filesList" :key="file.id">
            <b-button @click.prevent="exportPDF(file.id)"  size="lg" variant="outline-info" class="mr-2 mb-2" >
            <i class="fas fa-download font-size-16 align-middle mr-2"></i>{{file.name}}
            </b-button> 
        </div> -->
            <ul class="list-group list-group-flush">
                <li v-for="file in filesList" :key="file.id" class="list-group-item font-size-14">
                  <i class="fas fa-download font-size-16 align-middle mr-4 text-primary" @click.prevent="exportPDF(file.generatedName,file.name)" style="cursor: pointer;"></i> 
                    <i class="fas fa-trash font-size-16 align-middle mr-4 text-danger" @click.prevent="deletePDF(file.id,file.generatedName)" style="cursor: pointer;"></i> 
                  <span class="font-weight-bold text-dark "> {{file.name}}</span>    
                   
                </li>
            </ul>
           
    </div>
     <div v-if="isfilesListBusy" class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                    <span class=" sr-only">Chargement...</span>
                </div>
            </div>
            <span v-if="!isfilesListBusy & !filesList.length " class="d-flex justify-content-center m-4 text-danger text-center" >
                Aucune piéce jointe       
            </span>
    <vue-dropzone
        id="dropzone"
        ref="myVueDropzone"
        maxFileSizeInMB="1"
        maxNumberOfFiles="1"
        :use-custom-slot="true"
        :options="dropzoneOptions"
        >
        <div class="dropzone-custom-content">
            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
            <h4>Déposez un fichier ici ou cliquez pour uploader.</h4>
        </div>
    </vue-dropzone>
        <span v-if="noFileSelectedError" class="text-danger">Veillez selectionner un fichier!! </span> 

    <div  class="mt-4 mb-4 text-center">
        <b-button @click.prevent="saveProvidersFiles()"   variant="success"  >
            Enregistrer le fichier
        </b-button> 
    </div>  


    <b-alert show variant="warning" class="text-justify">
        <i class="mdi mdi-alert-outline mr-2"></i>La taille de fichier ne doit pas dépasser <span class="font-weight-bold" > {{this.maxFileSize}}</span>. 
    </b-alert>
    </div>
    </b-modal>
    <b-modal v-if="selected"
    v-model="showDetailsModal"
        :title="isLaboratory ? 'Gérer les Fournisseurs' : (isProvider ? 'Gérer les  Prestataires' : (isCustomer ? 'Gérer les  Clients' :'')) "
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger"
        size="xl"
        no-close-on-backdrop>
    <div class="zoom-container">
    <h4 class="card-title  text-secondary text-center">{{selected.id ? selected.name : (isLaboratory ? 'Ajouter un Nouveau Fournisseur' : (isProvider ? 'Ajouter un Nouveau Prestatire' : (isCustomer ? 'Ajouter un Nouveau Client' :''))) }}</h4><br>

    <form class="needs-validation" > 
        <div class="row">
            <div  :class=" isLaboratory  ? 'col-md-4 col-12':'col-md-6 col-12' " class="pl-md-3 pl-0 pr-md-1 pr-0">
                <div class="pb-0 mb-3">
                    <code> Informations Obligatoires </code>
                </div>
                <b-form-group class="pt-0 mb-1">
                    <b-form-checkbox
                        value="1"
                        unchecked-value="0"
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                        v-model="selected.status"
                        >   
                        <span class="font-size-14" v-if="isLaboratory" :class="selected.status == 1 ? 'text-primary' : 'text-muted'">{{selected.status == 1 ? 'Fournisseur Actif' : 'Fournisseur Desactivé'}}</span>
                        <span class="font-size-14" v-if="isProvider" :class="selected.status == 1 ? 'text-primary' : 'text-muted'">{{selected.status == 1 ? 'Prestataire Actif' : 'Prestataire Desactivé'}}</span>
                        <span class="font-size-14" v-if="isCustomer" :class="selected.status == 1 ? 'text-primary' : 'text-muted'">{{selected.status == 1 ? 'Client Actif' : 'Client Desactivé'}}</span>
                    </b-form-checkbox>
                </b-form-group>

                

                <b-form-group class="pt-0 mb-1" v-if="isLaboratory">
                    <b-form-checkbox
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                        v-model="selected.isPreOrderSupported"
                        >
                        <span class="font-size-14" v-if="isLaboratory" :class="selected.isPreOrderSupported ? 'text-primary' : 'text-muted'">Gestion des précommandes</span>
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group class="pt-0 mb-1" v-if="isLaboratory">
                    <b-form-checkbox
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                        v-model="selected.isInvoicingSupported"
                        >
                        <span class="font-size-14" v-if="isLaboratory" :class="selected.isInvoicingSupported ? 'text-primary' : 'text-muted'">Gestion de la Facturation</span>
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group class="pt-0 mb-3" v-if="isLaboratory">
                    <b-form-checkbox
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                        v-model="selected.isVisibleInList"
                        >
                        <span class="font-size-14" v-if="isLaboratory" :class="  selected.isVisibleInList ? 'text-primary' : 'text-muted'">Visible dans les Offres Permanentes </span>
                    </b-form-checkbox>
                </b-form-group>

                           

                <b-form-group>
                    <label for="name" class="pt-1 pb-1 font-size-14 font-weight-bold">Nom Commercial<span class="text-danger mb-2" style="font-size:0.6em">(obligatoire)</span></label>
                    <input
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.name"
                    />
                </b-form-group>
                <b-form-group>
                    <label for="name" class="pt-1 pb-1 font-size-14 font-weight-bold">Nom de l'Organisme</label>
                    <input
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.legalName"
                    />
                </b-form-group>
                <b-form-group>
                    <label for="address" class="pt-1 pb-1 font-size-14 font-weight-bold">Adresse<span class="text-danger mb-2" style="font-size:0.6em">(obligatoire)</span></label>
                    <input
                    id="address"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.address"
                    />
                </b-form-group>
                <b-form-group>
                    <label for="zipCode" class="pt-1 pb-1 font-size-14 font-weight-bold">Code Postal</label>
                    <input
                    id="zipCode"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.zipCode"
                    />
                </b-form-group>
                <b-form-group>
                    <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Pays<span class="text-danger mb-2" style="font-size:0.6em">(obligatoire)</span></label>
                    <v-select class="style-vselect" style="font-size:1em;" :options="countriesList" @input="getCities(); selected.city = null ; selected.town = null ;selected.locality = null" v-model="selected.country" placeholder="" label="name" >
                        <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select>   
                </b-form-group>
                <b-form-group>
                    <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Ville<span class="text-danger mb-2" style="font-size:0.6em">(obligatoire)</span></label>
                    <v-select class="style-vselect" style="font-size:1em;" :options="citiesList" @input="getTowns(); selected.town = null; selected.locality = null"  v-model="selected.city" placeholder="" label="name" >
                        <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select>   
                </b-form-group>
                <b-form-group  v-if="!isLaboratory && !isProvider">
                    <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Délégation</label>
                    <v-select class="style-vselect" style="font-size:1em;" :options="townsList" @input="getLocalities(); selected.locality = null"  v-model="selected.town" placeholder="" label="name" >
                        <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select>   
                </b-form-group>
                <b-form-group  v-if="!isLaboratory && !isProvider">
                    <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Localité</label>
                    <v-select class="style-vselect" style="font-size:1em;" :options="localityList"  v-model="selected.locality" placeholder="" label="name" >
                        <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select>   
                </b-form-group>
                <b-form-group v-if="isLaboratory">
                    <label for="instagram" class="pt-1 pb-1 font-size-14 font-weight-bold">Type de l'offre<span class="text-danger mb-2" style="font-size:0.6em">(obligatoire)</span></label>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0 text-primary">
                            <b-form-radio v-model="selected.offertype"  value="1">Sans Catégories</b-form-radio>
                        </div>

                        <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0  text-secondary">
                            <b-form-radio v-model="selected.offertype"   value="2">Avec Catégories</b-form-radio>
                        </div>
                    </div>
                </b-form-group>

                     

                
               

                
            </div>
            <div :class=" isLaboratory  ? 'col-md-4 col-12':'col-md-6 col-12' " class="pl-md-3 pl-0 pr-md-1 pr-0">
                <div class="pb-3">
                    <code> Informations Optionelles </code>
                </div>
                <b-form-group>
                    <label for="phone" class="pt-1 pb-1 font-size-14 font-weight-bold">Numéros de Téléphone</label>
                    <div class="row">
                        <div class="col-6 pr-2">
                            <input
                            id="phone"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="selected.phone"
                            />
                        </div>
                        <div class="col-6">
                            <input
                            id="Secondphone"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="selected.secondPhone"
                            />
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="mail" class="pt-1 pb-1 font-size-14 font-weight-bold">E-mail</label>
                    <input
                    id="mail"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.mail"
                    />
                </b-form-group>
                <b-form-group >
                    <label for="taxRefNumber" class="pt-1 pb-1 font-size-14 font-weight-bold">Matricule fiscale</label>
                    <input
                    id="taxRefNumber"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.taxRefNumber"
                    />
                </b-form-group>
                <b-form-group v-if="isCustomer">
                    <label for="instagram" class="pt-1 pb-1 font-size-14 font-weight-bold">Type de pharmacie</label>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0 text-primary">
                            <b-form-radio v-model="selected.type"  value="0">Jour</b-form-radio>
                        </div>

                        <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0  text-secondary">
                            <b-form-radio v-model="selected.type"   value="1">Nuit</b-form-radio>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group v-if="isLaboratory">
                    <label for="bank" class="pt-1 pb-1 font-size-14 font-weight-bold">Banque et RIB</label>
                    <div class="row">
                        <div class="col-6 pr-2">
                            <input
                            id="bank"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="selected.bank"
                            />
                        </div>
                        <div class="col-6">
                            <input
                            id="rib"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="selected.rib"
                            />
                        </div>
                    </div>
                </b-form-group>
                <b-form-group v-if="isLaboratory || isProvider">
                    <label for="web" class="pt-1 pb-1 font-size-14 font-weight-bold">Site Web</label>
                    <input
                    id="web"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.webSite"
                    placeholder="Le URL doit commencer par https://" 
                    />
                </b-form-group>
                <b-form-group v-if="isLaboratory || isProvider">
                    <label for="facebook" class="pt-1 pb-1 font-size-14 font-weight-bold">Facebook</label>
                    <input
                    id="facebook"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.facebook"
                    placeholder="Le URL doit commencer par https://" 
                    />
                </b-form-group>
                <b-form-group v-if="isLaboratory || isProvider">
                    <label for="instagram" class="pt-1 pb-1 font-size-14 font-weight-bold">Instagram</label>
                    <input
                    id="instagram"
                    type="text"
                    class="form-control font-size-13 "
                    v-model="selected.instagram"
                    placeholder="Le URL doit commencer par https://" 
                    />
                </b-form-group>
            </div>

            <div class="col-md-4 col-12 pl-md-3 pl-0 pr-md-1 pr-0 " v-if="isLaboratory">
                <div class="pb-3">
                    <code> Conditions Générales d'Achats  </code>
                </div>
                <b-form-group>
                    <label for="cashPaymentDiscount" class="pt-1 pb-1 font-size-14 font-weight-bold">Remise pour paiement comptant </label>
                    <div class="input-group" >
                        <input
                        id="cashPaymentDiscount"
                        type="number"
                        class="form-control font-size-13"
                        v-model="selected.cashPaymentDiscount"
                        /> 
                        <div class="input-group-append">
                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="invoiceDiscount" class="pt-1 pb-1 font-size-14 font-weight-bold">Remise sur facture </label>
                    <div class="input-group" >
                        <input
                        id="invoiceDiscount"
                        type="number"
                        class="form-control font-size-13"
                        v-model="selected.invoiceDiscount"
                        /> 
                        <div class="input-group-append">
                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="minOrderValue" class="pt-1 pb-1 font-size-14 font-weight-bold">Minimum de Commande </label>
                    <div class="input-group" >
                        <input
                        id="minOrderValue"
                        type="number"
                        class="form-control font-size-13"
                        v-model="selected.minOrderValue"
                        /> 
                        <div class="input-group-append">
                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">TND</span>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="minOrderItemsCount" class="pt-1 pb-1 font-size-14 font-weight-bold">Minimum de Références </label>
                    <input
                    id="minOrderItemsCount"
                    type="number"
                    class="form-control font-size-13"
                    v-model="selected.minOrderItemsCount"
                    /> 
                </b-form-group>
                <b-form-group>
                    <label for="paymentDays" class="pt-1 pb-1 font-size-14 font-weight-bold">Délai de Paiement</label>
                    <div class="input-group" >
                        <input
                        id="paymentDays"
                        type="number"
                        class="form-control font-size-13"
                        v-model="selected.paymentDays"
                        /> 
                        <div class="input-group-append">
                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">Jours</span>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="deliveryDays" class="pt-1 pb-1 font-size-14 font-weight-bold">Délai de Livraison</label>
                    <div class="input-group" >
                        <input
                        id="deliveryDays"
                        type="number"
                        class="form-control font-size-13"
                        v-model="selected.deliveryDays"
                        /> 
                        <div class="input-group-append">
                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">Jours</span>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="note" class="pt-1 pb-1 font-size-14 font-weight-bold">Note </label>
                    <input
                    id="note"
                    type="text"
                    class="form-control font-size-13"
                    v-model="selected.note"
                    /> 
                </b-form-group>
                <div class="row">
                    <div class="col-6 pr-2">
                        <b-form-group>
                            <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Reprise des périmés</label>
                            <v-select class="style-vselect" style="font-size:16px;" :options="expiredItemReturnList" v-model="selected.expiredItemReturn" placeholder="" label="name" >
                                <span slot="no-options">Aucun élément dans la liste</span>
                            </v-select>   
                        </b-form-group>
                    </div>
                    <div class="col-6">
                        <b-form-group>
                            <label for="expiredItemReturnString" class="pt-1 pb-1 font-size-14 font-weight-bold">Plus de Détails</label>
                            <input
                            id="expiredItemReturnString"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="selected.expiredItemReturnString"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>
        
            </div>
            <div v-if="isProvider" class="row"> 
                <div class="col-12  pl-4">
                    <div class="pb-3">
                        <code>Presentation de la societé </code>
                    </div>
                        <ckeditor v-model="selected.description" :editor="editor"></ckeditor>
                    </div>
   

            </div>
    </form>
    </div>

    <template v-slot:modal-footer>
        <b-button class="zoom-container" variant="secondary" @click="cancelEdit();showDetailsModal=false"  size="md">Annuler</b-button>
        <b-button  class="zoom-container" variant="primary" @click="isLaboratory|| isProvider ? saveSupplier() : saveCustomer()"  size="md" >Enregistrer</b-button>
    </template>
    </b-modal>

    <b-modal   v-if="selected.id"
            v-model="showContactModal"
            :title="'Editer les representants de '+selected.name"
            hide-footer 
            centered 
            title-class="text-warning"
            title-tag="h5"
            header-close-variant="danger"
            size="lg">
            <div class="zoom-container">
            <b-button
                variant="link"
                class="p-0 m-0 pb-3  text-primary font-weight-bold font-size-14 float-right" 
                @click="addNew()"
                >
                <i class="fas fa-edit " ></i>
                <span class="ml-2">Ajouter Nouveau</span>
            </b-button>
            <div v-if="showForm" class="row mt-4" style="width:100%">
                <div class="form-group col-sm-2 pr-2">
                <label >Prénom</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="selectedContact.firstName"
                />
                </div>
                <div class="form-group col-sm-2 pr-2">
                <label >Nom</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="selectedContact.lastName"

                />
                </div>
                <div class="form-group col-sm-2 pr-2">
                <label >Téléphone</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="selectedContact.phone"
                />
                </div>

                <div class="form-group col-sm-2 pr-2">
                <label >E-mail</label>
                <input  type="email" class="form-control"
                v-model="selectedContact.email"
                />
                </div>

                <div class="form-group col-sm-2 pr-2">
                <label >Position</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="selectedContact.position"
                />
                </div>
            <div class="col-sm-2" style="padding-top:26px; padding-bottom:26px;">
                <b-button variant="secondary" @click="cancelContactEdit();hideForm();" class="mr-2" >
                    <i class="fas fa-times font-size-14 align-middle  " ></i>
                </b-button>
                <b-button variant="success" @click="saveContact()" >
                <i class="fas fa-save font-size-14 align-middle  " ></i>
                </b-button>
            </div>
            </div> 
            <div class="table-responsive"  >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                <th class="text-left">Prénom</th>
                <th class="text-left">Nom</th>
                <th class="text-left">Téléphone </th>
                <th class="text-left">Email</th>
                <th class="text-left">Position</th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="contact in selected.contacts" :key="contact.id" >
                    <td>{{contact.firstName}}</td>
                    <td>{{contact.lastName}}</td>
                    <td>{{contact.phone}}</td>
                    <td>{{contact.email}}</td>
                    <td>{{contact.position}}</td>
                    <td>
                        <a  title="modifier" href="javascript:void(0);"  @click="editContact(contact)" class="action-icon text-warning pr-2" >
                            <i class="mdi mdi-pencil font-size-22"  />
                        </a>

                        <a  title="supprimer" href="javascript:void(0);"  @click="removeContact(contact)" class="action-icon text-danger " >
                            <i class="mdi mdi-trash-can font-size-22 " />
                        </a>
                    </td>
                </tr>
            </tbody>
            </table>
            <span v-if="this.selected && this.selected.contacts && !this.selected.contacts.length " class="d-flex justify-content-center m-4 text-danger" >Aucun contact dans la liste</span>

            </div> 
            </div>
    </b-modal>

    <b-modal
            v-if="showUsersModal && this.selectedUserList"
            v-model="showUsersModal"
            :title="'Editer les utilisateurs de '+selected.name" 
            hide-footer 
            centered 
            title-class="text-warning"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"
    >
    <div class="zoom-container">
    <b-button
            variant="link"
            class="p-0 m-0 pb-3  text-primary font-weight-bold font-size-14 float-right" 
            @click="addNew()"
            >
            <i class="fas fa-edit " ></i>
            <span class="ml-2">Ajouter Nouveau</span>
        </b-button>
        <div v-if="showForm" class="float-left">
            <div  class="form-group  ">
                <b-form-checkbox
                    value="1"
                    unchecked-value="0"
                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                    v-model="selectedUser.status"
                    >   
                    <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-primary' : 'text-muted'">{{selectedUser.status == 1 ? 'Utilisateur Active' : 'Utilisateur Desactivé'}}</span>
                </b-form-checkbox>
            </div>
        </div>
       
        <div v-if="isPasswordChange" class="row mt-4" style="width:100%">
            <div class="form-group row mb-3">
                <label class="col-md-5 col-form-label" for="pwd">Nouveau mot de passe de  {{selectedUser.userName}} </label>
                <div class="col-md-4">
                  <form autocomplete="off">
                        <input
                            type="password"
                            v-model="newPassword"
                            class="form-control"
                        />
                  </form>
                </div>
                <div class="col-md-3" >
                    <b-button variant="secondary" @click="cancelPasswordChangeEdit();" class="mr-2 ml-2" >
                        <i class="fas fa-times font-size-14 align-middle  " ></i>
                    </b-button>
                    <b-button variant="success" @click="updatePassword()" >
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>
        </div>
        <div v-if="showForm" class="row mt-4" style="width:100%">
            <div class="form-group col-sm-3 pr-2">
                <label >Nom D'utlisateur</label>
                <input
                type="text"
                class="form-control"
                v-model="selectedUser.name"
                />
            </div>
            <div class="form-group col-sm-3 pr-2">
                <label >Login</label>
                <input
                type="text"
                class="form-control"
                v-model="selectedUser.userName"

                />
            </div>
            <!-- <div v-if="isNew" class="form-group col-sm-3 pr-2">
                <label >Mot de Passe</label>
                <input
                type="text"
                class="form-control"
                v-model="selectedUser.password"
                />
            </div> -->

            <div v-if="isNew" class="form-group col-sm-3 pr-2">

                <label >Mot de Passe</label>
                <div class="input-group">
                    <input class="form-control" :type="!passwordHidden ? 'password':'text'" v-model="selectedUser.password">
                    <div class="input-group-append">
                        <span class="input-group-text"><i :class="!passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword" ></i></span>
                    </div>
                </div>

            </div>

            <div class="col-sm-2" style="padding-top:26px; padding-bottom:26px;">
            <b-button variant="secondary" @click="cancelUserEdit();hideForm();" class="mr-2" >
                <i class="fas fa-times font-size-14 align-middle  " ></i>
            </b-button>
            <b-button variant="success" @click="saveUser()" >
                <i class="fas fa-save font-size-14 align-middle  " ></i>
            </b-button>
        </div>
        </div>  
        <div class="table-responsive"  >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                <th class="text-left">Nom d'utilisateur</th>
                <th class="text-left">Login</th>
                <th></th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in selectedUserList" :key="user.id" >
                    <td>{{user.name}}</td>
                    <td>{{user.userName}}</td>
                    <td>
                        <b-button @click="changePassword(user)"  size="sm" variant="outline-dark"  >
                            <i class="fas fa-key font-size-16 align-middle mr-2"></i>Changer Mot de Passe
                        </b-button>
                    </td>
                    <td>
                        <a  title="modifier" href="javascript:void(0);"  @click="editUser(user)" class="action-icon text-warning pr-2" >
                            <i class="mdi mdi-pencil font-size-22"  />
                        </a>

                        <!-- <a  title="supprimer" href="javascript:void(0);"  @click="removeUser(user)" class="action-icon text-danger " >
                            <i class="mdi mdi-trash-can font-size-22 " />
                        </a> -->
                    </td>
                </tr>
            </tbody>
            </table>
            <span v-if="this.selectedUserList && !this.selectedUserList.length " class="d-flex justify-content-center m-4 text-danger" >Aucun Utilisateur dans la liste</span>

            </div> 
    </div>
    </b-modal>

    <b-modal v-model="showImageModal" 
    :title="'Logo de '+imageModalSelectedItem.name" 
    hide-footer 
    centered 
    title-class="text-warning"
    title-tag="h5"
    header-close-variant="danger">
    <div class="zoom-container">
        <div class="row p-2">
            <img v-bind:src="imageModalUrl"  alt style="width: 100%; height: 100%;" />
        </div>
        <b-alert show variant="warning" class="text-justify">
            <i class="mdi mdi-alert-outline mr-2"></i>La taille de l'image ne doit pas dépasser <span class="font-weight-bold" > {{this.maxFileSize}}</span>. 
            Les types supportés sont <span class="font-weight-bold"> PNG </span>, <span class="font-weight-bold">JPG </span>, <span class="font-weight-bold"> BMP</span>, et <span class="font-weight-bold">GIF</span>. 
        </b-alert>
            <input 
                type="file" 
                @change="onImageUpload"
                ref="imageInput"
                style="display:none"/>
            <div class="row">
                <div class="col-5 text-left">
                    <b-button variant="outline-info" class="mt-2"  @click="$refs.imageInput.click()">
                        <i class="fas fa-upload font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Modifier</span>
                    </b-button>
                </div>

                <div class="col-2">
                </div>

                <div class="col-5 text-right">
                    <b-button variant="outline-danger" class="mt-2"  @click="deleteImage()">
                        <i class="fas fa-times font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Supprimer</span>
                    </b-button>
                </div>
            </div>
    </div>
    </b-modal>
    </div>
</template>